/*
* @描述: 商机后台管理
* @版本: 1.0
* @作者: 冯强
* @创建时间: 2024-12-03 09:40:16
*/
<template>
    <div class="page_container">
        <el-tabs v-model="tabActiveName" class="list_page_tabs" @tab-click="handleClickTab">
            <el-tab-pane label="商机表单配置" name="form_site">
                <div class="business_form_site_wrap">
                    <ul class="business_form_site_list">
                        <li class="business_form_site_item" @click="handleClickFormSet('projects')">
                            <div class="flex_js_wrap">
                                <div class="flex_wrap">
                                    <img alt=""
                                         src="https://download.hecoos.com/enlightv/2024-50/9ab0ec1342b88b1513573a7ace464938.png">
                                    <span class="title">新增商机</span>
                                </div>
                                <el-link :underline="false" type="primary"><i
                                        class="iconfont icon-a-fenzu2"></i>
                                </el-link>
                            </div>
                            <p class="desc">设置新增商机时需填写的信息</p>
                        </li>
                        <li class="business_form_site_item" @click="handleClickFormSet('project_stage_tasks')">
                            <div class="flex_js_wrap">
                                <div class="flex_wrap">
                                    <img alt=""
                                         src="https://download.hecoos.com/enlightv/2024-50/4764e8ebe26a6e4ca72dd5c1cbb05aa0.png">
                                    <span class="title">阶段任务</span>
                                </div>
                                <el-link :underline="false"
                                         type="primary"><i
                                        class="iconfont icon-a-fenzu2"></i>
                                </el-link>
                            </div>
                            <p class="desc">设置各阶段员工需完成填写的信息，设置后在商机阶段配置中与阶段绑定</p>
                        </li>
                    </ul>
                </div>
            </el-tab-pane>
            <el-tab-pane label="商机阶段设置" name="stage_site">
                <div class="el_tab_pane_wrap stage_site_wrap">
                    <div v-if="pullSortHintShow" class="stage_site_drag_hint">
                        <div>
                            <i class="iconfont icon-shuoming"></i>
                            <span class="text">拖动后，新优先级顺序可能将某些商机的阶段变化，将于次日0点后生效</span>
                        </div>
                        <el-link :underline="false" type="primary" @click="pullSortHintShow=false">我知道了</el-link>
                    </div>
                    <div class="flex_js_wrap">
                        <p class="stage_site_hint">用于设置不同类型的商机的不同阶段，按住左侧可拖动更换优先级</p>
                        <el-button icon="el-icon-plus" size="small" type="primary" @click="handleClickAddFlow">新建流程
                        </el-button>
                    </div>
                    <div class="table_container">
                        <vxe-grid ref="stageTable"
                                  v-if="stageTableShow"
                                  v-bind="stageTableOptions"
                                  @row-dragend="stageTableRowDragendEvent">
                            <template #action="{ row }">
                                <span class="handle_icon_wrap" @click="handleClickEditFlow(row)">
                                    <i class="iconfont icon-bianji"></i>
                                </span>
                                <span class="line"></span>
                                <el-tooltip v-if="row.is_disabled===0" content="点击停用" effect="dark" placement="top">
                                    <span :class="{'handle_icon_disabled_wrap':row.is_system===1}"
                                          class="handle_icon_wrap handle_icon_danger_wrap"
                                          @click="handleClickDeactivateFlow(row)">
                                        <i class="iconfont icon-tingyong"></i>
                                    </span>
                                </el-tooltip>
                                <el-tooltip v-else content="点击启用" effect="dark" placement="top">
                                    <span :class="{'handle_icon_disabled_wrap':row.is_system===1}"
                                          class="handle_icon_wrap handle_icon_success_wrap"
                                          @click="handleClickDeactivateFlow(row)">
                                        <i class="iconfont icon-a-bingji3"></i>
                                    </span>
                                </el-tooltip>
                                <span class="line"></span>
                                <span :class="{'handle_icon_disabled_wrap':row.is_system===1}"
                                      class="handle_icon_wrap"
                                      @click="handleClickDelFlow(row)">
                                    <i class="iconfont icon-shanchu1"></i>
                                </span>
                            </template>
                        </vxe-grid>
                    </div>
                </div>
            </el-tab-pane>
            <el-tab-pane label="审批设置" name="approve_site">
                <div class="el_tab_pane_wrap">
                    <div class="approve_site_hint_wrap">
                        <span>开关开启，该业务操作需进行审批，具体审批流程请前往</span>
                        <el-link :underline="false" type="primary" @click="handleClickToApprovalBackendManagement">
                            审批->后台管理
                        </el-link>
                        <span>中配置</span>
                    </div>
                    <vxe-table :data="approveSiteData" border round>
                        <vxe-column field="name" title="业务名称"></vxe-column>
                        <vxe-column field="is_approve"
                                    title="是否需要审批"
                                    width="156">
                            <template #default="{ row }">
                                <el-switch v-model="row.is_approval"
                                           :active-value="1"
                                           :inactive-value="0"
                                           @change="handleIsApprovalChange(row)"></el-switch>
                            </template>
                        </vxe-column>
                        <vxe-column title="操作" width="80">
                            <template #default="{ row }">
                                <el-link :underline="false" type="primary" @click="handleClickApproveSetting(row)">
                                    前往设置
                                </el-link>
                            </template>
                        </vxe-column>
                    </vxe-table>
                </div>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>
<script>
import {
    approvalBusinessIsApprovalSet,
    approvalBusinessSetList,
    projectGroupDel,
    projectGroupIsDisabled,
    projectGroupList,
    projectGroupSort
} from "@/api";
import {EventBus} from "@/utils/eventBus";

export default {
    name: "BusinessManagement",
    data() {
        return {
            tabActiveName: 'form_site',
            stageTableOptions: {
                border: true,
                rowConfig: {
                    useKey: true,
                    drag: true
                },
                columnConfig: {
                    resizable: true,
                    useKey: true
                },
                rowDragConfig: {
                    icon: 'iconfont icon-a-move',
                    visibleMethod({row}) {
                        if (row.is_system === 1) {
                            return false
                        }
                        return true
                    }
                },
                seqConfig: {
                    seqMethod({rowIndex}) {
                        return `优先级${rowIndex + 1}`
                    }
                },
                columns: [
                    {type: 'seq', title: '优先级', minWidth: '100px', dragSort: true},
                    {field: 'name', title: '商机分组名称', minWidth: 100},
                    {field: 'applicable_rules', title: '适用商机', showOverflow: true, minWidth: 200},
                    {field: 'project_stages', title: '商机阶段', showOverflow: true, minWidth: 200},
                    {title: '操作', width: 125, slots: {default: 'action'},fixed: 'right'}
                ],
                data: []
            },
            sortable: null,
            oldBusinessStageList: [],
            stageTableShow: true,
            approveSiteData: [],
            pullSortHintShow: false,
        }
    },
    created() {
        if (this.$route.params.from && this.$route.params.from === 'set') {
            this.tabActiveName = 'stage_site'
            this.getBusinessGroupList()
        }
        EventBus.$on('stageSiteUpdated', this.eventBusFun);
    },
    mounted() {
    },
    methods: {
        handleClickTab(tab) {
            if (this.tabActiveName === 'stage_site') {
                if (this.stageTableOptions.data.length === 0) {
                    this.getBusinessGroupList()
                }
            } else if (this.tabActiveName === 'approve_site') {
                this.getApprovalSetList()
            }
        },

        eventBusFun() {
            if (this.tabActiveName === 'stage_site') {
                this.getBusinessGroupList()
            }
        },

        //点击修改表单按钮
        handleClickFormSet(type) {
            this.$router.push({
                name: "businessFormSet",
                query: {type}
            })
        },

        //获取商机组列表
        getBusinessGroupList() {
            projectGroupList().then(res => {
                if (res.code === 200) {
                    this.stageTableOptions.data = res.data.map(item => {
                        return {
                            ...item,
                            applicable_rules: item.applicable_rules.rules ? item.applicable_rules.rules.length ? item.applicable_rules.rules.map(rule => {
                                return rule.field_name + '：' + rule.field_text
                            }) : '其他全部商机' : '其他全部商机',
                            project_stages: item.project_stages.map(stage => {
                                return stage.name
                            }).join('、') + '、输单/赢单'
                        }
                    })
                    this.stageTableShow = true
                } else {

                }
            })
        },

        //流程表格拖拽结束事件
        stageTableRowDragendEvent() {
            this.pullSortHintShow = true
            const sort_data = this.$refs.stageTable.getFullData().map((item, index) => {
                return {
                    project_group_id: item.project_group_id,
                    sort: index + 1
                }
            })
            projectGroupSort({
                sort_data
            }).then(res => {
                if (res.code === 200) {
                    this.$message.success('排序成功')
                    this.stageTableShow = false
                    this.getBusinessGroupList()
                } else {

                }
            })
        },

        //点击新增流程按钮
        handleClickAddFlow() {
            this.$router.push({
                name: "businessFlowSet"
            })
        },

        // 点击编辑流程按钮
        handleClickEditFlow(row) {
            this.$router.push({
                name: "businessFlowSet",
                query: {
                    id: row.project_group_id
                }
            })
        },

        // 点击停用流程按钮
        handleClickDeactivateFlow(row) {
            if (row.is_system === 1) return false
            if (row.is_disabled === 0) {
                this.$msgbox({
                    title: '确认停用该流程？',
                    message: '停用后，将于次日0点后生效，原使用该流程的商机将切换至满足的新流程',
                    confirmButtonText: '停用',
                    cancelButtonText: '取消',
                    confirmButtonClass: 'el-button--danger',
                    iconClass: 'iconfont icon-shuoming',
                    showCancelButton: true,
                    closeOnClickModal: false,
                    closeOnPressEscape: false,
                    customClass: 'icon_title_message_box icon_title_message_box_danger'
                }).then(() => {
                    projectGroupIsDisabled({
                        project_group_id: row.project_group_id,
                        is_disabled: 1,
                    }).then(res => {
                        if (res.code === 200) {
                            this.$message.success('停用成功')
                            this.getBusinessGroupList()
                        } else {

                        }
                    })
                }).catch(() => {

                })
            } else {
                projectGroupIsDisabled({
                    project_group_id: row.project_group_id,
                    is_disabled: 0,
                }).then(res => {
                    if (res.code === 200) {
                        this.$message.success('启用成功')
                        this.getBusinessGroupList()
                    } else {

                    }
                })
            }
        },

        // 点击删除流程按钮
        handleClickDelFlow(row) {
            if (row.is_system === 1) return false
            this.$msgbox({
                title: '确认删除该流程？',
                message: '删除后，将于次日0点后生效，原使用该流程的商机将切换至满足的新流程',
                confirmButtonText: '删除',
                cancelButtonText: '取消',
                confirmButtonClass: 'el-button--danger',
                iconClass: 'iconfont icon-shuoming',
                showCancelButton: true,
                closeOnClickModal: false,
                closeOnPressEscape: false,
                customClass: 'icon_title_message_box icon_title_message_box_danger'
            }).then(() => {
                projectGroupDel({
                    project_group_id: row.project_group_id
                }).then(res => {
                    if (res.code === 200) {
                        this.$message.success('删除成功')
                        this.getBusinessGroupList()
                    } else {

                    }
                })
            }).catch(() => {

            })
        },

        //获取审批设置列表
        getApprovalSetList() {
            approvalBusinessSetList({
                business_type: 'project'
            }).then(res => {
                if (res.code === 200) {
                    this.approveSiteData = res.data
                } else {

                }
            }).catch(res => {

            })
        },

        //点击前往审批后台设置
        handleClickToApprovalBackendManagement() {
            this.$router.push({
                name: "approveAdminManagement"
            })
        },

        //是否需要审批切换事件
        handleIsApprovalChange(row) {
            approvalBusinessIsApprovalSet({
                approval_business_set_id: row.approval_business_set_id
            }).then(res => {
                if (res.code === 200) {
                    this.$message.success('设置成功')
                    this.getApprovalSetList()
                } else {

                }
            }).catch(() => {

            })
        },

        //前往审批设置
        handleClickApproveSetting(row) {
            this.$router.push({
                name: 'approveAdminSettings',
                query: {
                    id: row.approval_type_id
                }
            })
        },
    },
    beforeDestroy() {
        EventBus.$off('stageSiteUpdated', this.eventBusFun);
    },
}
</script>
<style lang="scss" scoped>
.business_form_site_wrap {
    padding: 24px;
    width: 100%;
    height: 100%;
    background-color: #F7F8FA;

    .business_form_site_list {
        display: flex;
        gap: 24px;
        justify-content: center;

        .business_form_site_item {
            width: 460px;
            padding: 24px;
            border-radius: 8px;
            background: #FFFFFF;
            border: 1px solid #E8E8E8;
            cursor: pointer;
            transition: all .3s;

            &:hover {
                box-shadow: 0 6px 16px 4px rgba(0, 0, 0, 0.08);
            }

            img {
                width: 22px;
                margin-right: 8px;
            }

            .title {
                color: #333333;
                font-weight: 700;
                line-height: 22px;
            }

            .desc {
                margin-top: 16px;
                color: #666666;
                line-height: 22px;
            }
        }
    }
}

.stage_site_wrap {

    .stage_site_drag_hint {
        padding: 8px 16px;
        border-radius: 4px;
        background: #FDF1DE;
        border: 1px solid #F9D9A3;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 16px;

        .icon-shuoming {
            color: #F0AA32;
            margin-right: 8px;
            vertical-align: middle;
        }

        .text {
            display: inline-block;
            line-height: 22px;
            color: #333333;
            vertical-align: middle;
        }
    }

    .stage_site_hint {
        color: #999999;
    }

    .table_container {
        width: 100%;
        height: calc(100% - 48px);
        border-radius: 4px;
        overflow-y: auto;
        margin-top: 16px;

        ::v-deep .vxe-cell--drag-handle .icon-a-move {
            cursor: move;
            color: #999999;
        }
    }
}
</style>